// import i18n from '@/api/i18n/i18n';

const typeDict = {
  // 31: i18n.t('pages.typeDict.incoming'),
  // 32: i18n.t('pages.typeDict.outgoing'),
  31: 'incoming',
  32: 'outgoing',
};

export const type = (val) => typeDict[val];
